import React from 'react';
import { BreakpointKeyType } from 'crehana-ui/styles/types';

import matchMediaQuery from 'Jsx/Utils/matchMediaQuery';

function useMediaQuery(breakpoint: BreakpointKeyType | string) {
  const nativeMediaQueryList = matchMediaQuery(breakpoint);
  const [matches, setMatches] = React.useState(nativeMediaQueryList.matches);

  nativeMediaQueryList.addListener(event => {
    setMatches(event.matches);
  });

  return { matches, nativeMediaQueryList };
}

export default useMediaQuery;
